<div class="page-container">
  <div class="center-icon-container">
    <mat-icon [svgIcon]="svgIcon" class="center-icon">{{icon}}</mat-icon>
  </div>
  <div class="page-body">
    <ng-content></ng-content>
  </div>
</div>
